





























import {
  computed,
  defineComponent,
  onMounted,
  PropType,
  ref,
  vue3Model
} from '~/utils/nuxt3-migration'
import { useDep, useDeps } from '~/compositions/dependency-container'
import LoanService from '~/services/loan/LoanService'
import { LoanMerchantName } from '~/models/loan'
import { diffInSeconds } from '~/utils/date'
import PopularityService from '~/services/popularity/PopularityService'
import { OnlineLoanType } from '~/constants/loan/loans'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_VIEW_NS,
  ClassifiedViewState
} from '~/store/modules/shared/classifieds/view/state'

export default defineComponent({
  model: vue3Model,
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    amount: {
      type: Number,
      required: true
    },
    installments: {
      type: Number,
      required: true
    },
    sessionId: {
      type: String,
      required: true
    },
    loanType: {
      type: String as PropType<OnlineLoanType>,
      required: false,
      default: 'auto-loan'
    }
  },
  setup(props, { emit }) {
    const [loanService] = useDeps(LoanService)

    const iframeUrl = ref('')
    const iframeLoaded = ref('false')

    const startTime = ref<Date | number | null>(null)
    const popularityService = useDep(PopularityService)
    const { state } = useNamespacedStore<ClassifiedViewState>(
      CLASSIFIED_VIEW_NS
    )

    const visible = computed({
      get() {
        startTime.value = Date.now()
        return props.modelValue
      },
      set(value: boolean) {
        if (value === false && startTime.value) {
          const diff = diffInSeconds(Date.now(), startTime.value)
          popularityService.recordEvent('public_modal_open_duration', {
            session_id: props.sessionId,
            seconds: diff
          })
          startTime.value = null
        }

        emit('update:modelValue', value)
      }
    })

    onMounted(() => {
      loadIframeUrl()
      window.addEventListener('beforeunload', onBeforeUnload)
    })

    function onBeforeUnload() {
      if (visible.value) {
        // if modal is visible and we are leaving
        popularityService.recordEvent('public_modal_before_unload', {
          session_id: props.sessionId
        })
      }
    }

    async function loadIframeUrl() {
      const { targetUrl } = await loanService.getLoanTarget(
        LoanMerchantName.TBI,
        props.amount,
        props.installments,
        props.loanType,
        state.classifiedId
      )
      iframeUrl.value = targetUrl
    }

    return { visible, iframeUrl, iframeLoaded, startTime }
  }
})
